const art174DisabledWhen = '!$root.code || $root.code !== "OW004_ART174_DEDUCTIONS"';

export const customDocumentValueProperties = {
  ranges: {
    title: 'Zakresy',
    disabled: art174DisabledWhen,
    type: 'array',
    items: {
      type: 'object',
      properties: {
        dateFrom: {
          title: 'od',
          type: 'string',
          format: 'date',
          maximum: 'this.dateTo',
          fieldRequired: true,
          validationMessages: {
            minimum: 'Data nie może być późniejsza niż data {{maximum}}.'
          }
        },
        dateTo: {
          title: 'do',
          type: 'string',
          format: 'date',
          minimum: 'this.dateFrom',
          fieldRequired: true,
          validationMessages: {
            minimum: 'Data nie może być wcześniejsza niż data {{minimum}}.'
          }
        },
        days: {
          title: 'liczba dni',
          type: 'number',
          computed: true,
          calc: [
            'if (!this.dateFrom || !this.dateTo) {',
            '  return 0;',
            '}',
            'const start = $methods.moment(this.dateFrom, "YYYY-MM-DD", true);',
            'const end = $methods.moment(this.dateTo, "YYYY-MM-DD", true);',
            'if (!start.isValid() || !end.isValid() || end.isBefore(start, "day")) {',
            '  return 0;',
            '}',
            'return end.diff(start, "days") + 1;'
          ]
        }
      }
    }
  },
  totalDays: {
    title: 'Łączna liczba dni',
    disabled: art174DisabledWhen,
    type: 'number',
    calc: ['return (this.ranges || []).reduce(function (sum, row) {', '  return sum + (row.days || 0);', '}, 0);']
  }
};
